// extracted by mini-css-extract-plugin
export const button = "Button-module--button--1RGO-";
export const buttonDarkGrey = "Button-module--button--dark-grey--2HC21";
export const buttonGrey = "Button-module--button--grey--2GgW5";
export const button__background = "Button-module--button__background--3iNmM";
export const button__content = "Button-module--button__content--3wqhB";
export const buttonWhite = "Button-module--button--white--3O3sO";
export const buttonBlue = "Button-module--button--blue--1XtCy";